interface IDashboardHeaderProps {
    heading: string;
    rightChildren?: JSX.Element;
}
const DashboardHeader = (props: IDashboardHeaderProps) => {

    return (
        <div className="flex flex-col md:flex-row md:justify-between">
            <div className='font-bold text-3xl py-2'>{props.heading}</div>
            <div>
                {props.rightChildren}
            </div>
        </div>
        
    )
}

export default DashboardHeader;